import { render, staticRenderFns } from "./verificationCenter.vue?vue&type=template&id=ca7d3db8&scoped=true&"
import script from "./verificationCenter.vue?vue&type=script&lang=js&"
export * from "./verificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./verificationCenter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./verificationCenter.vue?vue&type=style&index=1&id=ca7d3db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7d3db8",
  null
  
)

component.options.__file = "verificationCenter.vue"
export default component.exports